import http from "./client";
import { ISettings } from "../entryes/panel/Filestorage/Settings";

async function statistic(courseId: number | string) {
  const response = await http.get('/api/files/coursestorage', {
    params: { course_id: courseId }
  });
  
  return response.data;
}

async function getSettings(courseId: number | string) {
  const response = await http.get('/api/files/coursestoragesettings', {
    params: { 
      course_id: courseId
    }
  });

  return response.data;
}

async function saveSettings(courseId: number | string, settings: string) {
  const response = await http.post('/api/files/savecoursestoragesettings', {
    course_id: courseId,
    settings: settings
  });

  return response.data;
}

async function openStorage(courseId: number | string, status: string) {
  const response = await http.post('/panel/scope/edit', {}, {
    params: {
      course_id: courseId,
      setting: 'openstorage',
      status: status
    }
  });

  return response.data;
}

async function clearNow(courseId: number | string, withSave: boolean, settings: string) {
  const response = await http.post('/api/files/clearnow', {
    withSave: withSave,
    settings: settings,
  }, {
    params: {
      course_id: courseId,
    }
  });

  return response.data
}

const courseStorage = {
  statistic, getSettings, saveSettings, openStorage, clearNow
}

export default courseStorage;